import get from 'lodash.get';
import find from 'lodash.find';

const getThumbnail = photos => {
    const versions = get(photos, '[0].versions');
    return get(
        find(versions, {
            type: {
                name: 'thumb',
            },
        }),
        'webPath'
    );
};

export const createItemForAutoModal = item => {
    const { id, serviceId, title, photos } = item || {};

    return {
        id: id || serviceId,
        title,
        image: getThumbnail(photos),
    };
};



// WEBPACK FOOTER //
// ./assets/js/global/components/AutoModal/autoModalHelpers.es.js